import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('approversEntityUserGroup');

import { queryEditActive } from './service';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'approversEntityUserGroup',
  state: {
    newApproversGroup: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,approvalLevel,entityValue',
    notSelectSearch: 'approvalLevel',
    expand: {
      userGroup: { select: 'name' },
      dynamicEntity: { select: 'displayName' },
      dynamicEntityField: { select: 'displayName' },
    },
    paramsView: {
      select: 'id,approvalLevel,entityValue,updated,created',
      expand: {
        userGroup: { select: 'name' },
        dynamicEntity: { select: 'displayName' },
        dynamicEntityField: { select: 'displayName' },
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select: 'id,approvalLevel,userGroupId,dynamicEntityId,dynamicEntityFieldId,entityValue',
    },
    view: false,
    orderBy: '',
    id: null,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'globalEntityApproverByUserGroup/paged',
          params: payload,
        });
        yield put({
          type: 'queryApproversGroups',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *addNewApproversGroup({ payload }, { put }) {
      yield put({
        type: 'addApproversGroups',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewApprovers',
          payload,
        });
      }
    },
    *saveNewApproversGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'globalEntityApproverByUserGroup',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApproversGroup',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *editItemApproversGroup({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'globalEntityApproverByUserGroup',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editApproversGroups',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveEditApproversGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'globalEntityApproverByUserGroup',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveApproversGroup',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        const response = yield call(api.apiRoute, {
          route: `globalEntityApproverByUserGroup/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'saveApproversGroup',
          payload: response,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        if (error && error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *showItemUser({ view }, { put }) {
      yield put({
        type: 'showEditItemUser',
        view,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
  },
  reducers: {
    queryApproversGroups(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addApproversGroups(state, { payload }) {
      return {
        ...state,
        newApproversGroup: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editOrViewApprovers(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    editApproversGroups(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    saveApproversGroup(state, { payload }) {
      return {
        ...state,
        saveApproversGroup: payload,
        newApproversGroup: false,
        selectedItem: null,
        view: false,
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },
    showEditItemApproversGroup(state, { view }) {
      return {
        ...state,
        view,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        newApproversGroup: false,
        selectedItem: null,
        formConfig: null,
        list: [],
        view: false,
        orderBy: '',
      };
    },
  },
};

export default Model;
